import { sagaFunctions } from "../../config/helper";
import { apis } from "../../config/apis";
import { takeLatest } from "redux-saga/effects";
import {
  ForgotPassoword,
  Marketings,
  NewPassoword,
  Notifications,
  PriceWorker,
  Register,
  ResetPassoword,
  Sessions,
  SelectCustomer,
  Logout,
  GetDelegateUsers,
  CreateDelegateUser,
  DeleteDelegateUser,
  UpdateDelegateUser,
  Timezone,
  UserDashboard,
  UserProfile,
  WarrentyDocs,
} from "./Action";
import { GetProfomaDoc, UpdateProfomaDoc } from "../orders";

function register(req) {
  return sagaFunctions(Register, "post", apis.register, req.payload)();
}

function timezone(req) {
  return sagaFunctions(Timezone, "get", apis.timezone_fetch, req.payload)();
}


function prize_worker(req) {
  return sagaFunctions(PriceWorker, "get", apis.price_update_worker, req.payload)();
}

function notifications() {
  return sagaFunctions(Notifications, "get", apis.alerts_list, {
    email: localStorage.getItem("email"),
  })();
}

function dashboard(req) {
  return sagaFunctions(UserDashboard, "get", apis.dashboard, req.payload)();
}

function update_sales_order_status(req) {
  return sagaFunctions(
    UpdateProfomaDoc,
    "post",
    apis.update_sales_order_status,
    req.payload
  )();
}

function get_proforma_doc(req) {
  return sagaFunctions(
    GetProfomaDoc,
    "get",
    apis.get_proforma_doc,
    req.payload
  )();
}

function get_delegate_users(req) {
  return sagaFunctions(
    GetDelegateUsers,
    "get",
    apis.get_delegate_users,
    req.payload
  )();
}

function create_delegate_user(req) {
  return sagaFunctions(
    CreateDelegateUser,
    "post",
    `${apis.create_delegate_user}?email=${localStorage.getItem("email")}`,
    {
      customer: {
        name: req.payload.name,
        email: req.payload.email,
        module_permissions: req.payload.module_permissions
      }
    }
  )();
}

function update_delegate_user(req) {
  const id = req.payload.id;
  return sagaFunctions(
    UpdateDelegateUser,
    "post",
    apis.update_delegate_user(id),
    {
      customer: {
        name: req.payload.name,
        email: req.payload.email,
        module_permissions: req.payload.module_permissions
      }
    }
  )();
}

function delete_delegate_user(req) {
  const id = req.payload.id;
  return sagaFunctions(
    DeleteDelegateUser,
    "post",
    apis.delete_delegate_user(id),  // call function with id
    req.payload
  )();
}

function sessions(req) {
  let url = apis.sessions
  if (req.payload.isSupport) {
    url = apis.support_sessions
    delete req.payload.isSupport
  }
  return sagaFunctions(Sessions, "post", url, req.payload)();
}

function selectCustomer(req) {
  return sagaFunctions(
    SelectCustomer,
    "post",
    apis.select_customer,
    req.payload
  )();
}


function logout(req){
  return sagaFunctions(Logout, "get", apis.logout, req.payload)();
}

function new_password(req) {
  return sagaFunctions(NewPassoword, "post", apis.new_password, req.payload)();
}

function forgot_password(req) {
  return sagaFunctions(
    ForgotPassoword,
    "get",
    apis.forgot_password,
    req.payload
  )();
}

function user_profile(req) {
  return sagaFunctions(UserProfile, "get", apis.profile, req.payload)();
}

function marketings(req) {
  return sagaFunctions(Marketings, "get", apis.marketings, {
    email: localStorage.getItem("email"),
    ...req.payload
  })();
}

function warrenty_docs() {
  return sagaFunctions(WarrentyDocs, "get", apis.fetch_warranty, {
    email: localStorage.getItem("email"),
  })();
}

function reset_password(req) {
  return sagaFunctions(
    ResetPassoword,
    "post",
    apis.reset_password,
    req.payload
  )();
}

export function* registerWatcher() {
  yield takeLatest(Timezone.REQUEST, timezone);
  yield takeLatest(PriceWorker.REQUEST, prize_worker);
  yield takeLatest(Register.REQUEST, register);
  yield takeLatest(Sessions.REQUEST, sessions);
  yield takeLatest(SelectCustomer.REQUEST, selectCustomer);
  yield takeLatest(NewPassoword.REQUEST, new_password);
  yield takeLatest(ForgotPassoword.REQUEST, forgot_password);
  yield takeLatest(ResetPassoword.REQUEST, reset_password);
  yield takeLatest(UserDashboard.REQUEST, dashboard);
  yield takeLatest(GetProfomaDoc.REQUEST, get_proforma_doc);
  yield takeLatest(UpdateProfomaDoc.REQUEST, update_sales_order_status);
  yield takeLatest(UserProfile.REQUEST, user_profile);
  yield takeLatest(Notifications.REQUEST, notifications);
  yield takeLatest(WarrentyDocs.REQUEST, warrenty_docs);
  yield takeLatest(Marketings.REQUEST, marketings);
  yield takeLatest(Logout.REQUEST, logout);
  yield takeLatest(CreateDelegateUser.REQUEST, create_delegate_user);
  yield takeLatest(GetDelegateUsers.REQUEST, get_delegate_users);
  yield takeLatest(DeleteDelegateUser.REQUEST, delete_delegate_user);
  yield takeLatest(UpdateDelegateUser.REQUEST, update_delegate_user);
}
